import { CalendarIcon, DownloadIcon, FilterIcon, SearchIcon, XIcon } from '@heroicons/react/outline'
// import { Tooltip } from "antd";
import 'antd/lib/tooltip/style/css'
import 'antd/lib/skeleton/style/css'
import moment from 'moment'
import Popover from 'components/molecules/Popover'
import Layout from 'containers/Layout'
import _, { debounce, get, isEmpty, last, split } from 'lodash'
import { useEffect, useState, useRef, Fragment, useMemo } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import Transactions from './Transactions'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import { enUS, arSA } from 'date-fns/locale'
import { defaultStaticRanges, defaultInputRanges } from 'react-date-range/dist/defaultRanges'
import useModal from 'hooks/useModal'
import queryString from 'query-string'
import { useSelector } from 'react-redux'
import Selection from 'components/molecules/Selection'
import { IoInformationCircleSharp, IoFilter } from 'react-icons/io5'
import ToolTip from 'components/atoms/Tooltip'
import Bookings from './Bookings'
import ActivityLogs from './ActivityLogs'
import Button from 'components/atoms/Button'
import { Dialog, Transition } from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from 'components/atoms/LanguageSwitcher'
import apiGet from 'lib/network/apiGet'
import apiGetBlob from 'lib/network/apiGetBlob'
import apiPost from 'lib/network/apiPost'
import notify from 'components/atoms/Notify'
import { getLocalizedCountries } from 'pages/company/modals/countries'
import { isCompanyDashboardUser, isPartnerDashboardUser, usesTenantDashboardUi } from 'lib/auth/dashboardRole'

// import Button from "components/atoms/Button";

const CreatedBy = [
  { id: 'user', name: 'User' },
  { id: 'admin', name: 'Admin' },
  { id: 'office', name: 'Office' },
  { id: 'partner', name: 'Partner' },
]

const BookingStatus = [
  { id: 'pending', name: 'Pending' },
  { id: 'confirmed', name: 'Confirmed' },
  { id: 'underReview', name: 'UnderReview' },
  { id: 'cancelled', name: 'Cancelled' },
  { id: 'rejected', name: 'Rejected' },
  { id: 'completed', name: 'Completed' },
  { id: 'inProgress', name: 'InProgress' },
  { id: 'failedPayment', name: 'Failed Payment' },
]

const PaymentStatus = [
  { id: 'paid', name: 'Paid' },
  { id: 'unpaid', name: 'Unpaid' },
  { id: 'failure', name: 'Failure' },
  { id: 'waiting_for_payment_approval', name: 'Waiting For Payment Approval' },
  { id: 'refund', name: 'Refund' },
  { id: 'partialpaid', name: 'Partial Paid' },
  { id: 'partialrefund', name: 'Partially Refunded' },
]

const PaymentMethod = [
  { id: 'Thawani', name: 'Thawani' },
  { id: 'Paymob', name: 'Paymob' },
  { id: 'Wallet', name: 'Wallet' },
]

const TransactionStatus = [
  { id: 'initiated', name: 'Initiated' },
  { id: 'completed', name: 'Completed' },
  { id: 'canceled', name: 'Cancelled' },
]

const booleanFilterOptions = [
  { id: '', name: 'All' },
  { id: 'true', name: 'Yes' },
  { id: 'false', name: 'No' },
]

const parseQueryArray = value => {
  if (_.isNil(value) || value === '') return []
  if (_.isArray(value)) return value.map(String).filter(Boolean)
  return split(String(value), ',')
    .map(s => _.trim(s))
    .filter(Boolean)
}

const getInitialBookingFilterState = () => {
  const qs = queryString.parse(window.location.search)
  return {
    companyIds: parseQueryArray(qs.companyIds),
    companyGovernorates: parseQueryArray(qs.companyGovernorates),
    blockedCountries: parseQueryArray(qs.blockedCountries),
    companyMinAge: qs.companyMinAge || '',
    companyMaxAge: qs.companyMaxAge || '',
    instantBooking: qs.instantBooking || null,
    ajarleePercentageMin: qs.ajarleePercentageMin || '',
    ajarleePercentageMax: qs.ajarleePercentageMax || '',
    companyDepositMin: qs.companyDepositMin || '',
    companyDepositMax: qs.companyDepositMax || '',
    vatTax: qs.vatTax || null,
    delivery: qs.delivery || null,
    deliveryFeeMin: qs.deliveryFeeMin || '',
    deliveryFeeMax: qs.deliveryFeeMax || '',
    bookDateTime: qs.bookDateTime === 'true',
    bookStartDateTime: qs.bookStartDateTime === 'true',
    bookEndDateTime: qs.bookEndDateTime === 'true',
  }
}

const Reports = () => {
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const downloadCSV = useRef()
  const initialBookingFilters = useMemo(() => getInitialBookingFilterState(), [])

  const [dateRange, setDateRange] = useState({})
  const [search, setSearch] = useState('')
  const [searchKey, setSearchKey] = useState('')
  const [q, setQueryData] = useState({})
  const [downloading, setDownloading] = useState(false)
  const [showMobileFilters, setShowMobileFilters] = useState(false)
  const [showDesktopFilters, setShowDesktopFilters] = useState(false)

  const [workspace, setWorkspace] = useState(null)
  const [scanStatus, setScanStatus] = useState(null)
  const [bookingCreatedBy, setBookingCreatedBy] = useState(null)
  const [bookingStatus, setBookingStatus] = useState(null)
  const [paymentStatus, setPaymentStatus] = useState(null)
  const [paymentMethod, setPaymentMethod] = useState(null)
  const [status, setStatus] = useState(null)
  const [partner, setPartner] = useState(null)
  const [partners, setPartners] = useState([])
  const [companies, setCompanies] = useState([])
  const [companyIds, setCompanyIds] = useState(initialBookingFilters.companyIds)
  const [companyGovernorates, setCompanyGovernorates] = useState(initialBookingFilters.companyGovernorates)
  const [companyMinAge, setCompanyMinAge] = useState(initialBookingFilters.companyMinAge)
  const [companyMaxAge, setCompanyMaxAge] = useState(initialBookingFilters.companyMaxAge)
  const [blockedCountries, setBlockedCountries] = useState(initialBookingFilters.blockedCountries)
  const [instantBooking, setInstantBooking] = useState(initialBookingFilters.instantBooking)
  const [ajarleePercentageMin, setAjarleePercentageMin] = useState(initialBookingFilters.ajarleePercentageMin)
  const [ajarleePercentageMax, setAjarleePercentageMax] = useState(initialBookingFilters.ajarleePercentageMax)
  const [companyDepositMin, setCompanyDepositMin] = useState(initialBookingFilters.companyDepositMin)
  const [companyDepositMax, setCompanyDepositMax] = useState(initialBookingFilters.companyDepositMax)
  const [vatTax, setVatTax] = useState(initialBookingFilters.vatTax)
  const [delivery, setDelivery] = useState(initialBookingFilters.delivery)
  const [deliveryFeeMin, setDeliveryFeeMin] = useState(initialBookingFilters.deliveryFeeMin)
  const [deliveryFeeMax, setDeliveryFeeMax] = useState(initialBookingFilters.deliveryFeeMax)
  const currentWorkspace = useSelector(state => get(state, 'user.workspace')) || {}
  const userFromStore = useSelector(state => get(state, 'user.user'))
  // eslint-disable-next-line
  const hasAdminAccess = userFromStore?.roles?.some(role => role.type === 'admin')
  // eslint-disable-next-line
  const isCompanyRole = isCompanyDashboardUser(userFromStore)
  const isPartnerOnly = isPartnerDashboardUser(userFromStore)
  const usesTenantUi = usesTenantDashboardUi(userFromStore)
  /** Admin-only: lists are built from the full companies API and expose other tenants. */
  const showCrossCompanyFilters = hasAdminAccess && !isPartnerOnly
  const showCompanyBookingFilters = !isPartnerOnly
  const showMinMaxAgeFilter = hasAdminAccess || !isCompanyRole
  const showCreatedByFilter = hasAdminAccess || (!isCompanyRole && !isPartnerOnly)
  const canCreateBooking = hasAdminAccess || (isCompanyRole && !hasAdminAccess)
  const bookingStatusOptions = isCompanyRole && !hasAdminAccess ? BookingStatus.filter(option => option.id !== 'failedPayment') : BookingStatus

  const [bookDateTime, setBookDateTime] = useState(initialBookingFilters.bookDateTime)
  const [bookStartDateTime, setBookStartDateTime] = useState(initialBookingFilters.bookStartDateTime)
  const [bookEndDateTime, setBookEndDateTime] = useState(initialBookingFilters.bookEndDateTime)
  const [exportingBookings, setExportingBookings] = useState(false)
  const [showJourneyReportModal, setShowJourneyReportModal] = useState(false)
  const [generatingJourneyReport, setGeneratingJourneyReport] = useState(false)
  const [journeySendEmail, setJourneySendEmail] = useState(false)
  const [journeyDateRange, setJourneyDateRange] = useState({
    startDate: moment().startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
    key: 'selection',
  })
  const journeyDatePopover = useRef()

  const [date, setDate] = useState(null)

  const type = last(split(history.location.pathname, '/'))

  const [path, setPath] = useState(type)
  const user = useSelector(state => get(state, 'user.user'))

  // Check if current language is RTL (Arabic)
  const isRTL = i18n.language === 'ar'
  const datePickerLocale = useMemo(() => (isRTL ? arSA : enUS), [isRTL])

  const localizedStaticRanges = useMemo(() => {
    const labels = {
      Today: t('reports.datePicker.today'),
      Yesterday: t('reports.datePicker.yesterday'),
      'This Week': t('reports.datePicker.thisWeek'),
      'Last Week': t('reports.datePicker.lastWeek'),
      'This Month': t('reports.datePicker.thisMonth'),
      'Last Month': t('reports.datePicker.lastMonth'),
    }
    return defaultStaticRanges.map(range => ({
      ...range,
      label: labels[range.label] || range.label,
    }))
  }, [t])

  const localizedInputRanges = useMemo(() => {
    const inputRanges = defaultInputRanges.map(range => {
      if (range.label === 'days up to today') {
        return { ...range, label: t('reports.datePicker.continuous') }
      }
      if (range.label === 'days starting today') {
        return { ...range, label: t('reports.datePicker.early') }
      }
      return range
    })
    if (inputRanges.length === 2 && !inputRanges[0]._isLocalizedTabs) {
      inputRanges[0]._isLocalizedTabs = true
    }
    return inputRanges
  }, [t])

  useEffect(() => {
    setPath(path)
  }, [type])

  useEffect(() => {
    if (currentWorkspace?.id !== workspace && currentWorkspace) {
      setWorkspace(currentWorkspace?.id)
    }
  }, [currentWorkspace.id])

  useEffect(() => {
    if ((isCompanyRole || isPartnerOnly) && !hasAdminAccess) {
      return
    }
    const fetchPartners = async () => {
      try {
        const response = await apiGet('partners', { pageSize: 1000 })
        if (response?.data?.partners) {
          setPartners(response.data.partners)
        }
      } catch (error) {
        console.error('Error fetching partners:', error)
      }
    }
    fetchPartners()
  }, [hasAdminAccess, isCompanyRole, isPartnerOnly])

  useEffect(() => {
    if (isPartnerOnly || (isCompanyRole && !hasAdminAccess)) return

    const fetchCompanies = async () => {
      try {
        const response = await apiGet('companies', { pageSize: 1000 })
        if (response?.success) {
          const list = _.isArray(response?.data?.company)
            ? response.data.company
            : _.isArray(response?.data?.companies)
            ? response.data.companies
            : _.isArray(response?.data)
            ? response.data
            : []
          setCompanies(list)
        }
      } catch (error) {
        console.error('Error fetching companies:', error)
        setCompanies([])
      }
    }

    fetchCompanies()
  }, [isPartnerOnly, isCompanyRole, hasAdminAccess])

  // Memoized so every keystroke shares one timer; a fresh debounce per render lets stale values race.
  const searchFn = useMemo(() => debounce(value => setSearch(value), 1000), [])

  function handleChange(event) {
    setSearchKey(event.target.value)
    searchFn(event.target.value)
  }

  const handleSelect = range => {
    const startDate = new Date(range.range1.startDate)
    startDate.setHours(0, 0, 0, 0)

    const endDate = new Date(range.range1.endDate)

    // Check if same day
    const isSameDay = startDate.getFullYear() === endDate.getFullYear() && startDate.getMonth() === endDate.getMonth() && startDate.getDate() === endDate.getDate()

    if (isSameDay) {
      endDate.setHours(23, 59, 59, 999)
    } else {
      endDate.setHours(23, 59, 59, 999)
    }

    // Format dates using native methods to ensure English numerals
    const formatDate = d => {
      const year = d.getFullYear()
      const month = _.padStart(String(d.getMonth() + 1), 2, '0')
      const day = _.padStart(String(d.getDate()), 2, '0')
      const hours = _.padStart(String(d.getHours()), 2, '0')
      const minutes = _.padStart(String(d.getMinutes()), 2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    }

    const sd = formatDate(startDate)
    const ed = formatDate(endDate)

    setDate({ ...range.range1 })
    setDateRange({ sd, ed })
  }

  useEffect(() => {
    const qs = queryString.parse(window.location.search)
    if (qs.ed && qs.sd) {
      setDate({ startDate: new Date(qs.sd), endDate: new Date(qs.ed) })
      setDateRange({ sd: qs.sd, ed: qs.ed })
    }

    if (qs.q) {
      setQueryData(JSON.parse(qs.q))
    }
    if (qs.bookingCreatedBy) {
      setBookingCreatedBy(qs.bookingCreatedBy)
    }
    if (qs.bookingStatus) {
      setBookingStatus(qs.bookingStatus)
    }
    if (qs.paymentStatus) {
      setPaymentStatus(qs.paymentStatus)
    }
    if (qs.paymentMethod) {
      setPaymentMethod(qs.paymentMethod)
    }
    if (qs.status) {
      setStatus(qs.status)
    }
    if (qs.partner) {
      setPartner(qs.partner)
    }
  }, [])

  const getConditionalText = type => {
    switch (type) {
      case 'email':
        return 'someone@gmail.com'
      case 'walletAddress':
        return '0x29D7.....D24c3'
      case 'campaign':
        return 'someCampaign'
      case 'source':
        return 'someSource'
      case 'locale':
        return 'someLocale'
      case 'medium':
        return 'someMedium'
      default:
        return 'placeholder'
    }
  }

  const getToolTipContent = type => {
    const placeholder = getConditionalText(type)
    return (
      <div className="w-[300px] py-2 px-2">
        <ul style={{ listStyleType: 'number' }} className="text-sm text-normal text-gray-700 ml-2">
          <li>
            <q className="bg-gray-200 px-1 rounded font-bold">=</q> allows you to match exact ones.
          </li>

          <ul style={{ listStyleType: 'circle' }} className="text-sm text-normal text-gray-700 ml-2 mt-1 mb-3">
            <li>
              <div>
                <span className="px-1 bg-gray-200 rounded text-dark">= &apos;{placeholder}&apos;</span>
              </div>
            </li>
          </ul>
          <li>
            <q className="bg-gray-200 px-1 rounded font-bold">Like</q> allows you to match on similar values
          </li>
          <ul style={{ listStyleType: 'circle' }} className="text-sm text-normal text-gray-700 ml-2 mt-1 mb-3">
            <li>
              <span className="px-1 bg-gray-200 rounded text-dark">LIKE &apos;%{placeholder}%&apos;</span>
            </li>
          </ul>
          <li>
            <q className="bg-gray-200 px-1 rounded font-bold">NOT</q> can put before any conditional statement to select rows for which that statement is false.
          </li>
          <ul style={{ listStyleType: 'circle' }} className="text-sm text-normal text-gray-700 ml-2 mt-1">
            <li>
              <span className="px-1 bg-gray-200 rounded text-dark">NOT LIKE &apos;{placeholder}&apos;</span>
            </li>
          </ul>
        </ul>
      </div>
    )
  }

  const regFilterHeader = [
    { label: 'Email', key: 'email', tableKey: 'user.email', toolTipContent: getToolTipContent('email') },
    { label: 'Wallet', key: 'walletAddress', tableKey: 'user.walletAddress', toolTipContent: getToolTipContent('walletAddress') },
    { label: 'Campaign', key: 'campaign.name', tableKey: 'campaign.name', toolTipContent: getToolTipContent('campaign') },
    { label: 'Source', key: 'campaign.source', tableKey: 'campaign.source', toolTipContent: getToolTipContent('source') },
    { label: 'Locale', key: 'campaign.locale', tableKey: 'campaign.locale', toolTipContent: getToolTipContent('locale') },
    { label: 'Medium', key: 'campaign.medium', tableKey: 'campaign.medium', toolTipContent: getToolTipContent('medium') },
  ]

  const handleCreatedByChange = value => {
    setBookingCreatedBy(prevValue => (prevValue === value?.id ? null : value?.id || null))
  }

  const handlePaymentMethodChange = value => {
    setPaymentMethod(prevValue => (prevValue === value?.id ? null : value?.id || null))
  }

  const handleBookingStatusChange = value => {
    setBookingStatus(prevValue => (prevValue === value?.id ? null : value?.id || null))
  }
  const handlePaymentStatusChange = value => {
    setPaymentStatus(prevValue => (prevValue === value?.id ? null : value?.id || null))
  }
  const handleTransactionStatusChange = value => {
    setStatus(prevValue => (prevValue === value?.id ? null : value?.id || null))
  }

  const handlePartnerChange = value => {
    setPartner(prevValue => (prevValue === value?.id ? null : value?.id || null))
  }

  const companyOptions = (_.isArray(companies) ? companies : []).map(c => ({ id: c._id, name: c.name }))
  const governorateOptions = [...new Set((_.isArray(companies) ? companies : []).map(c => c.governorate).filter(Boolean))].map(g => ({ id: g, name: g }))
  const blockedCountriesOptions = getLocalizedCountries(i18n.language || 'en').map(c => ({ id: c.id, name: c.name }))

  const handleBookingsExport = async () => {
    setExportingBookings(true)
    try {
      const qs = window.location.search ? `${window.location.search.slice(1)}` : ''
      const url = qs ? `bookings/export?${qs}` : 'bookings/export'
      const blob = await apiGetBlob(url)
      if (!blob) {
        setExportingBookings(false)
        return
      }
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = `bookings_export_${moment().format('YYYY-MM-DD')}`
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error exporting bookings:', error)
    }
    setExportingBookings(false)
  }

  const handleGenerateJourneyReport = async () => {
    if (!journeyDateRange?.startDate || !journeyDateRange?.endDate) {
      notify.error('User Journey Report', 'Please select a date range')
      return
    }

    setGeneratingJourneyReport(true)
    try {
      const payload = {
        startDate: moment(journeyDateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(journeyDateRange.endDate).format('YYYY-MM-DD'),
        sendEmail: journeySendEmail,
      }

      const response = await apiPost('user-journey-reports', payload)
      if (response?.success) {
        const report = response?.data?.report
        const emailSent = response?.data?.emailSent
        const reportId = report?._id || report?.id

        if (reportId) {
          try {
            const blob = await apiGetBlob(`user-journey-reports/${reportId}/download`)
            if (blob) {
              const blobUrl = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = blobUrl
              link.download = report?.fileName || `user-journey-report-${moment().format('YYYY-MM-DD')}.xlsx`
              link.target = '_blank'
              link.rel = 'noopener noreferrer'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              window.URL.revokeObjectURL(blobUrl)
            }
          } catch (downloadError) {
            // eslint-disable-next-line no-console
            console.error('Error downloading user journey report:', downloadError)
          }
        }

        notify.success('User Journey Report', emailSent ? 'Report generated, emailed, and downloaded successfully' : 'Report generated and downloaded successfully')
        setJourneyDateRange({
          startDate: moment().startOf('day').toDate(),
          endDate: moment().endOf('day').toDate(),
          key: 'selection',
        })
        setJourneySendEmail(false)
        setShowJourneyReportModal(false)
      } else {
        notify.error('User Journey Report', response?.message || 'Failed to generate report')
      }
    } catch (error) {
      notify.error('User Journey Report', error?.message || 'Failed to generate report')
    } finally {
      setGeneratingJourneyReport(false)
    }
  }

  const CustomFilters = ({ q }) => {
    const [queries, setQueries] = useState(q)
    return (
      <div>
        <div className="grid grid-cols-6 gap-6">
          {regFilterHeader?.map((item, index) => {
            return (
              <div key={index} className="col-span-6 sm:col-span-3">
                <label htmlFor="first-name" className="block flex text-sm font-medium text-gray-700">
                  {item.label}{' '}
                  <ToolTip content={item?.toolTipContent}>
                    <IoInformationCircleSharp className="h-5 ml-1 w-4 text-gray-400" />
                  </ToolTip>
                </label>
                <input
                  value={queries[item.tableKey]}
                  onChange={e => setQueries({ ...queries, [item.tableKey]: e.target.value })}
                  placeholder="Raw Queries"
                  type="text"
                  className="mt-1 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            )
          })}
        </div>
        <div className="flex border-t border-gray-100 mt-8 pt-4 justify-end">
          <button
            onClick={() => closeModal()}
            type="button"
            className="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              closeModal()
              setQueryData(queries)
            }}
            type="button"
            className="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Apply
          </button>
          <button
            disabled={isEmpty(q)}
            onClick={() => {
              // setQueries({});
              setQueryData({})
              closeModal()
            }}
            type="button"
            className="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Clear
          </button>
        </div>
      </div>
    )
  }
  const scannerStatus = [
    { id: 'DENIED', name: 'Denied' },
    { id: 'GRANTED', name: 'Granted' },
  ]
  const popover = useRef()
  const workspaces = useSelector(state => get(state, 'user.workspaces'))

  const [Modal, openModal, closeModal] = useModal({
    dimensions: { minHeight: 'auto', height: 'auto' },
    title: 'Filters',
    width: 'auto',
    height: 'auto',
    description: (
      <span>
        Each field must have a comparison operator, if no operator is added, then <span className="px-1 bg-gray-200 rounded text-dark font-bold">=</span> will be used as the
        default comparison operator
      </span>
    ),
    content: <CustomFilters q={q} />,
  })

  return (
    <Layout
      background="#f4f5f9"
      title={''}
      headerRight={
        <div className="flex flex-col sm:flex-row items-start sm:items-center w-full justify-end gap-2 sm:gap-4">
          {/* Mobile Filters Toggle - Only visible on mobile/tablet */}
          <div className="flex items-center justify-between w-full sm:hidden mb-4">
            <Button onClick={() => setShowMobileFilters(true)} variant="outline" className="flex items-center gap-2">
              <IoFilter className="h-4 w-4" />
              {t('reports.filters.title')}
            </Button>
          </div>

          {/* Desktop Layout - Hidden on mobile/tablet */}
          <div className="hidden sm:flex flex-col sm:flex-row items-start sm:items-center w-full justify-end gap-2 sm:gap-4">
            {/* Download Button */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
              {(type === 'registrations' || history.location.pathname === '/reports/external/transactions' || history.location.pathname === '/reports/external/users') &&
                !user.export && (
                  <button
                    onClick={(e, done) => {
                      if (!downloading) {
                        downloadCSV.current.download(setDownloading, response => {})
                      }
                    }}
                    type="button"
                    className="border px-2 flex justify-center items-center h-8 shadow-sm text-sm rounded-md bg-white border-gray-300 w-full sm:w-auto"
                  >
                    {downloading ? (
                      <svg className="animate-spin h-5 w-5 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    ) : (
                      <DownloadIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                    )}
                  </button>
                )}
            </div>

            {type !== 'bookings' && (
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full sm:w-auto">
                {type === 'transactions' && (
                  <Selection
                    value={paymentMethod}
                    onChange={handlePaymentMethodChange}
                    className="min-w-[200px] w-full sm:w-auto"
                    list={PaymentMethod}
                    title={t('reports.filters.paymentMethod')}
                  />
                )}
                {type === 'transactions' && (
                  <Selection
                    value={status}
                    onChange={handleTransactionStatusChange}
                    className="min-w-[200px] w-full sm:w-auto"
                    list={TransactionStatus}
                    title={t('reports.filters.transactionStatus')}
                  />
                )}

                {type === 'registrations' && (
                  <button
                    onClick={() => {
                      openModal()
                    }}
                    type="button"
                    className="border px-2 flex justify-center items-center h-8 shadow-sm text-sm rounded-md text-gray-400 bg-white border-gray-300 w-full sm:w-auto"
                  >
                    <FilterIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                  </button>
                )}

                {user.isPlatformAdmin && (
                  <Selection
                    onChange={value => {
                      setWorkspace(value.id)
                    }}
                    className="min-w-[200px] w-full sm:w-auto"
                    value={workspace}
                    list={workspaces}
                    title={t('reports.filters.workspace')}
                  />
                )}

                {/* Scan Status Filter */}
                {type === 'event-logs' && (
                  <Selection
                    onChange={value => {
                      setScanStatus(value.id)
                    }}
                    className="min-w-[100px] w-full sm:w-auto"
                    value={scanStatus}
                    list={scannerStatus}
                    title={t('reports.filters.scanStatus')}
                  />
                )}
              </div>
            )}

            <Popover
              custom
              placement="right"
              ref={popover}
              content={close => (
                <DateRangePicker
                  weekStartsOn={0}
                  locale={datePickerLocale}
                  staticRanges={localizedStaticRanges}
                  inputRanges={localizedInputRanges}
                  startDatePlaceholder={t('reports.datePicker.early')}
                  endDatePlaceholder={t('reports.datePicker.continuous')}
                  footerContent={
                    <>
                      <button
                        onClick={close}
                        className="w-[100px] mt-4 py-2 mr-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 outline-none"
                      >
                        {t('reports.datePicker.close')}
                      </button>
                      <button
                        disabled={!dateRange?.sb && !dateRange?.ed}
                        onClick={() => {
                          setDateRange({ sd: '', ed: '' })
                          setDate({ startDate: '', endDate: '' })
                        }}
                        className="w-[100px] mt-4 py-2 mr-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 outline-none"
                      >
                        {t('reports.datePicker.clear')}
                      </button>

                      {type === 'bookings' && (
                        <div className="flex flex-col gap-2 items-start mt-4">
                          <label className="flex items-center space-x-2  px-2 py-1 rounded w-auto">
                            <input type="checkbox" checked={bookDateTime} onChange={e => setBookDateTime(e.target.checked)} />
                            <span>{t('reports.filters.bookDateTime')}</span>
                          </label>
                          <label className="flex items-center space-x-2 px-2 py-1 rounded w-auto">
                            <input type="checkbox" checked={bookStartDateTime} onChange={e => setBookStartDateTime(e.target.checked)} />
                            <span>{t('reports.filters.bookStartDateTime')}</span>
                          </label>
                          <label className="flex items-center space-x-2  px-2 py-1 rounded w-auto">
                            <input type="checkbox" checked={bookEndDateTime} onChange={e => setBookEndDateTime(e.target.checked)} />
                            <span>{t('reports.filters.bookEndDateTime')}</span>
                          </label>
                        </div>
                      )}
                    </>
                  }
                  ranges={[{ ...date }]}
                  onChange={(date, a, b, c) => handleSelect(date, close, a, b, c)}
                />
              )}
            >
              <button
                type="button"
                className="inline-flex w-full sm:w-[250px] h-[30px] justify-center items-center border border-gray-300 shadow-sm text-sm leading-4 font-regular rounded-md text-gray-700 bg-white hover:bg-gray-50 outline-none"
              >
                <CalendarIcon className={`h-4 w-4 text-gray-500 ${isRTL ? 'ml-4' : 'mr-4'}`} />
                <span className="truncate">
                  {dateRange.sd && dateRange.ed
                    ? `${moment(dateRange.sd).format('MMM Do, YYYY')}  -  ${moment(dateRange.ed).format('MMM Do, YYYY')}`
                    : t('reports.filters.selectDateRange')}
                </span>
              </button>
            </Popover>

            {/* Search - Keep outside drawer */}
            {location.pathname !== '/audits' && (
              <div className="w-full sm:max-w-[200px]">
                <label htmlFor="search" className="sr-only">
                  {t('reports.filters.search')}
                </label>
                <div className="relative">
                  <div className={`absolute inset-y-0 ${isRTL ? 'right-0 pr-3' : 'left-0 pl-3'} flex items-center pointer-events-none`}>
                    <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </div>
                  <input
                    onChange={handleChange}
                    id="search"
                    value={searchKey}
                    name="search"
                    className={`block ${
                      isRTL ? 'pr-10 pl-3' : 'pl-10 pr-3'
                    } py-1 border border-gray-300 rounded-md leading-5 bg-white shadow-sm placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 sm:text-sm`}
                    placeholder={t('reports.filters.search')}
                    type="search"
                  />
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
              {type === 'bookings' && (
                <Button onClick={() => setShowDesktopFilters(true)} variant="outline" className="flex items-center gap-2">
                  <IoFilter className="h-4 w-4 mr-2" />
                  {t('reports.filters.moreFilters')}
                </Button>
              )}
              {type === 'bookings' && hasAdminAccess && (
                <Button onClick={handleBookingsExport} disabled={exportingBookings} variant="outline" className="flex items-center gap-2 w-full sm:w-auto">
                  {exportingBookings ? (
                    <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      />
                    </svg>
                  ) : (
                    <DownloadIcon className="h-4 w-4" />
                  )}
                  Export Users
                </Button>
              )}
              {type === 'bookings' && hasAdminAccess && (
                <Button onClick={() => setShowJourneyReportModal(true)} variant="outline" className="flex items-center gap-2 w-full sm:w-auto">
                  <CalendarIcon className="h-4 w-4" />
                  User Journey Report
                </Button>
              )}
              {type === 'bookings' && canCreateBooking && (
                <Button onClick={() => history.push('/create/booking')} className="w-full sm:w-auto">
                  {t('companyDashboard.buttons.createBooking')}
                </Button>
              )}
            </div>

            <Modal></Modal>
          </div>
        </div>
      }
    >
      {/* Mobile Filters Drawer */}
      <Transition.Root show={showMobileFilters} as={Fragment}>
        <Dialog as="div" className="relative z-[11000] sm:hidden" onClose={setShowMobileFilters}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className={`pointer-events-none fixed inset-y-0 ${isRTL ? 'right-0 flex max-w-full pl-10' : 'left-0 flex max-w-full pr-10'}`}>
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom={isRTL ? 'translate-x-full' : '-translate-x-full'}
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo={isRTL ? 'translate-x-full' : '-translate-x-full'}
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="text-lg font-medium text-gray-900">{t('reports.filters.title')}</Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              onClick={() => setShowMobileFilters(false)}
                            >
                              <span className="sr-only">Close panel</span>
                              <XIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 px-4 sm:px-6">
                        <div className="space-y-6">
                          {/* Type-specific Filters */}
                          {type === 'bookings' && (
                            <>
                              {showCrossCompanyFilters && (
                                <>
                                  <div>
                                    <div className="block text-sm font-medium text-gray-700 mb-2">Company Name</div>
                                    <Selection
                                      multiple
                                      value={companyIds}
                                      onChange={ids => setCompanyIds(ids || [])}
                                      className="w-full"
                                      list={companyOptions}
                                      title="Select company(s)"
                                    />
                                  </div>
                                  <div>
                                    <div className="block text-sm font-medium text-gray-700 mb-2">Location of Company</div>
                                    <Selection
                                      multiple
                                      value={companyGovernorates}
                                      onChange={ids => setCompanyGovernorates(ids || [])}
                                      className="w-full"
                                      list={governorateOptions}
                                      title="Select governorate(s)"
                                    />
                                  </div>
                                </>
                              )}
                              {showCompanyBookingFilters && (
                                <>
                                  {showMinMaxAgeFilter && (
                                    <div className="grid grid-cols-2 gap-3">
                                      <div>
                                        <label htmlFor="booking-filter-company-min-age-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                          Min Age
                                        </label>
                                        <input
                                          id="booking-filter-company-min-age-mobile"
                                          type="number"
                                          min="0"
                                          value={companyMinAge}
                                          onChange={e => setCompanyMinAge(e.target.value)}
                                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                          placeholder="Min"
                                        />
                                      </div>
                                      <div>
                                        <label htmlFor="booking-filter-company-max-age-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                          Max Age
                                        </label>
                                        <input
                                          id="booking-filter-company-max-age-mobile"
                                          type="number"
                                          min="0"
                                          value={companyMaxAge}
                                          onChange={e => setCompanyMaxAge(e.target.value)}
                                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                          placeholder="Max"
                                        />
                                      </div>
                                    </div>
                                  )}
                                  <div>
                                    <div className="block text-sm font-medium text-gray-700 mb-2">Blocked Countries</div>
                                    <Selection
                                      multiple
                                      showSearch
                                      value={blockedCountries}
                                      onChange={ids => setBlockedCountries(ids || [])}
                                      className="w-full"
                                      list={blockedCountriesOptions}
                                      title="Select blocked countries"
                                    />
                                  </div>
                                  <div>
                                    <div className="block text-sm font-medium text-gray-700 mb-2">Instant Booking</div>
                                    <Selection
                                      value={instantBooking}
                                      onChange={value => setInstantBooking(value?.id || null)}
                                      className="w-full"
                                      list={booleanFilterOptions}
                                      title="Instant Booking"
                                    />
                                  </div>
                                </>
                              )}
                              <div className="grid grid-cols-2 gap-3">
                                <div>
                                  <label htmlFor="booking-filter-ajarlee-min-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                    Ajarlee % (From)
                                  </label>
                                  <input
                                    id="booking-filter-ajarlee-min-mobile"
                                    type="number"
                                    min="0"
                                    value={ajarleePercentageMin}
                                    onChange={e => setAjarleePercentageMin(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                    placeholder="From"
                                  />
                                </div>
                                <div>
                                  <label htmlFor="booking-filter-ajarlee-max-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                    Ajarlee % (To)
                                  </label>
                                  <input
                                    id="booking-filter-ajarlee-max-mobile"
                                    type="number"
                                    min="0"
                                    value={ajarleePercentageMax}
                                    onChange={e => setAjarleePercentageMax(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                    placeholder="To"
                                  />
                                </div>
                              </div>
                              <div className="grid grid-cols-2 gap-3">
                                <div>
                                  <label htmlFor="booking-filter-deposit-min-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                    Deposit Amount (From)
                                  </label>
                                  <input
                                    id="booking-filter-deposit-min-mobile"
                                    type="number"
                                    min="0"
                                    value={companyDepositMin}
                                    onChange={e => setCompanyDepositMin(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                    placeholder="From"
                                  />
                                </div>
                                <div>
                                  <label htmlFor="booking-filter-deposit-max-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                    Deposit Amount (To)
                                  </label>
                                  <input
                                    id="booking-filter-deposit-max-mobile"
                                    type="number"
                                    min="0"
                                    value={companyDepositMax}
                                    onChange={e => setCompanyDepositMax(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                    placeholder="To"
                                  />
                                </div>
                              </div>
                              <div>
                                <div className="block text-sm font-medium text-gray-700 mb-2">VAT Tax</div>
                                <Selection value={vatTax} onChange={value => setVatTax(value?.id || null)} className="w-full" list={booleanFilterOptions} title="VAT Tax" />
                              </div>
                              <div>
                                <div className="block text-sm font-medium text-gray-700 mb-2">Delivery</div>
                                <Selection value={delivery} onChange={value => setDelivery(value?.id || null)} className="w-full" list={booleanFilterOptions} title="Delivery" />
                              </div>
                              <div className="grid grid-cols-2 gap-3">
                                <div>
                                  <label htmlFor="booking-filter-delivery-fee-min-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                    Delivery Fees (From)
                                  </label>
                                  <input
                                    id="booking-filter-delivery-fee-min-mobile"
                                    type="number"
                                    min="0"
                                    value={deliveryFeeMin}
                                    onChange={e => setDeliveryFeeMin(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                    placeholder="From"
                                  />
                                </div>
                                <div>
                                  <label htmlFor="booking-filter-delivery-fee-max-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                                    Delivery Fees (To)
                                  </label>
                                  <input
                                    id="booking-filter-delivery-fee-max-mobile"
                                    type="number"
                                    min="0"
                                    value={deliveryFeeMax}
                                    onChange={e => setDeliveryFeeMax(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                    placeholder="To"
                                  />
                                </div>
                              </div>
                              {showCreatedByFilter && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.createdBy')}</label>
                                  <Selection
                                    value={bookingCreatedBy}
                                    onChange={handleCreatedByChange}
                                    className="w-full"
                                    list={CreatedBy.map(option => ({
                                      ...option,
                                      name: t(`bookings.createdBy.${option.id}`, { defaultValue: option.name }),
                                    }))}
                                    title={t('reports.filters.createdBy')}
                                  />
                                </div>
                              )}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.bookingStatus')}</label>
                                <Selection
                                  value={bookingStatus}
                                  onChange={handleBookingStatusChange}
                                  className="w-full"
                                  list={bookingStatusOptions.map(option => ({
                                    ...option,
                                    name: t(`bookings.status.${option.id}`, { defaultValue: option.name }),
                                  }))}
                                  title={t('reports.filters.bookingStatus')}
                                />
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.paymentStatus')}</label>
                                <Selection
                                  value={paymentStatus}
                                  onChange={handlePaymentStatusChange}
                                  className="w-full"
                                  list={PaymentStatus.map(option => ({
                                    ...option,
                                    name: t(`bookings.paymentStatus.${option.id}`, { defaultValue: option.name }),
                                  }))}
                                  title={t('reports.filters.paymentStatus')}
                                />
                              </div>
                              {!usesTenantUi && (
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.partner')}</label>
                                  <Selection
                                    value={partner}
                                    onChange={handlePartnerChange}
                                    className="w-full"
                                    list={partners.map(p => ({ id: p._id, name: p.name }))}
                                    title={t('reports.filters.partner')}
                                  />
                                </div>
                              )}
                            </>
                          )}

                          {type === 'transactions' && (
                            <>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.paymentMethod')}</label>
                                <Selection
                                  value={paymentMethod}
                                  onChange={handlePaymentMethodChange}
                                  className="w-full"
                                  list={PaymentMethod}
                                  title={t('reports.filters.paymentMethod')}
                                />
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.transactionStatus')}</label>
                                <Selection
                                  value={status}
                                  onChange={handleTransactionStatusChange}
                                  className="w-full"
                                  list={TransactionStatus}
                                  title={t('reports.filters.transactionStatus')}
                                />
                              </div>
                            </>
                          )}

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.dateRange')}</label>

                            <Popover
                              custom
                              placement={isRTL ? 'right-start' : 'left-start'}
                              offset={[0, 8]}
                              content={close => (
                                <div className="bg-white rounded-lg shadow-lg border border-gray-200 flex flex-col w-full h-full max-h-screen overflow-auto">
                                  {/* Date Range Picker Section */}
                                  <div className="flex-1 p-4">
                                    <DateRangePicker
                                      weekStartsOn={0}
                                      locale={datePickerLocale}
                                      staticRanges={localizedStaticRanges}
                                      inputRanges={localizedInputRanges}
                                      startDatePlaceholder={t('reports.datePicker.early')}
                                      endDatePlaceholder={t('reports.datePicker.continuous')}
                                      footerContent={null}
                                      ranges={[{ ...date }]}
                                      onChange={(range, a, b, c) => handleSelect(range, close, a, b, c)}
                                    />
                                  </div>

                                  {/* Footer Section */}
                                  <div className="border-t border-gray-200 bg-gray-50 p-4 space-y-3">
                                    {type === 'bookings' && (
                                      <div className="flex flex-col gap-2 pb-3 border-b border-gray-200">
                                        <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 px-2 py-1.5 rounded transition-colors">
                                          <input
                                            type="checkbox"
                                            checked={bookDateTime}
                                            onChange={e => setBookDateTime(e.target.checked)}
                                            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                          />
                                          <span className="text-sm text-gray-700">{t('reports.filters.bookDateTime')}</span>
                                        </label>
                                        <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 px-2 py-1.5 rounded transition-colors">
                                          <input
                                            type="checkbox"
                                            checked={bookStartDateTime}
                                            onChange={e => setBookStartDateTime(e.target.checked)}
                                            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                          />
                                          <span className="text-sm text-gray-700">{t('reports.filters.bookStartDateTime')}</span>
                                        </label>
                                        <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 px-2 py-1.5 rounded transition-colors">
                                          <input
                                            type="checkbox"
                                            checked={bookEndDateTime}
                                            onChange={e => setBookEndDateTime(e.target.checked)}
                                            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                          />
                                          <span className="text-sm text-gray-700">{t('reports.filters.bookEndDateTime')}</span>
                                        </label>
                                      </div>
                                    )}

                                    {/* Action Buttons */}
                                    <div className="flex gap-2 justify-end">
                                      <button
                                        disabled={!dateRange?.sd && !dateRange?.ed}
                                        onClick={() => {
                                          setDateRange({ sd: '', ed: '' })
                                          setDate({ startDate: '', endDate: '' })
                                        }}
                                        className="px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                      >
                                        {t('reports.datePicker.clear')}
                                      </button>
                                      <button
                                        onClick={close}
                                        className="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dark-600 hover:bg-dark-700 transition-colors"
                                      >
                                        {t('reports.datePicker.close')}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            >
                              <button
                                type="button"
                                className="inline-flex w-full h-[40px] justify-between items-center px-3 border border-gray-300 shadow-sm text-sm leading-4 font-regular rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                              >
                                <div className="flex items-center gap-2 flex-1 min-w-0">
                                  <CalendarIcon className={`h-4 w-4 text-gray-500 flex-shrink-0 ${isRTL ? 'ml-2' : 'mr-2'}`} />
                                  <span className="truncate text-left">
                                    {dateRange.sd && dateRange.ed
                                      ? `${moment(dateRange.sd).format('MMM Do, YYYY')} - ${moment(dateRange.ed).format('MMM Do, YYYY')}`
                                      : t('reports.filters.selectDateRange')}
                                  </span>
                                </div>
                                <svg className={`h-4 w-4 text-gray-400 flex-shrink-0 ${isRTL ? 'mr-2' : 'ml-2'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                              </button>
                            </Popover>
                          </div>

                          {/* Search */}
                          {location.pathname !== '/audits' && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.search')}</label>
                              <div className="relative">
                                <div className={`absolute inset-y-0 ${isRTL ? 'right-0 pr-3' : 'left-0 pl-3'} flex items-center pointer-events-none`}>
                                  <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </div>
                                <input
                                  onChange={handleChange}
                                  id="mobile-search"
                                  value={searchKey}
                                  name="search"
                                  className={`block w-full ${
                                    isRTL ? 'pr-10 pl-3' : 'pl-10 pr-3'
                                  } py-2 border border-gray-300 rounded-md leading-5 bg-white shadow-sm placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 sm:text-sm`}
                                  placeholder={t('reports.filters.search')}
                                  type="search"
                                />
                              </div>
                            </div>
                          )}

                          {/* Workspace Filter */}
                          {user.isPlatformAdmin && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.workspace')}</label>
                              <Selection
                                onChange={value => {
                                  setWorkspace(value.id)
                                }}
                                className="w-full"
                                value={workspace}
                                list={workspaces}
                                title={t('reports.filters.workspace')}
                              />
                            </div>
                          )}

                          {/* Scan Status Filter */}
                          {type === 'event-logs' && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.scanStatus')}</label>
                              <Selection
                                onChange={value => {
                                  setScanStatus(value.id)
                                }}
                                className="w-full"
                                value={scanStatus}
                                list={scannerStatus}
                                title={t('reports.filters.scanStatus')}
                              />
                            </div>
                          )}

                          {/* Advanced Filters for Registrations */}
                          {type === 'registrations' && (
                            <div>
                              <button
                                onClick={() => {
                                  setShowMobileFilters(false)
                                  openModal()
                                }}
                                type="button"
                                className="w-full border px-4 py-2 flex justify-center items-center h-10 shadow-sm text-sm rounded-md text-gray-400 bg-white border-gray-300"
                              >
                                <FilterIcon className="h-5 w-5 text-gray-500 mr-2" aria-hidden="true" />
                                {t('reports.filters.advancedFilters')}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={showDesktopFilters} as={Fragment}>
        <Dialog as="div" className="relative z-[11000] hidden sm:block" onClose={setShowDesktopFilters}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className={`pointer-events-none fixed inset-y-0 ${isRTL ? 'right-0 flex max-w-full pl-10' : 'left-0 flex max-w-full pr-10'}`}>
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom={isRTL ? 'translate-x-full' : '-translate-x-full'}
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo={isRTL ? 'translate-x-full' : '-translate-x-full'}
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="text-lg font-medium text-gray-900">{t('reports.filters.title')}</Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              onClick={() => setShowDesktopFilters(false)}
                            >
                              <span className="sr-only">Close panel</span>
                              <XIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 px-4 sm:px-6">
                        <div className="space-y-6">
                          {/* Booking Filters Only */}
                          {showCrossCompanyFilters && (
                            <>
                              <div>
                                <div className="block text-sm font-medium text-gray-700 mb-2">Company Name</div>
                                <Selection
                                  multiple
                                  value={companyIds}
                                  onChange={ids => setCompanyIds(ids || [])}
                                  className="w-full"
                                  list={companyOptions}
                                  title="Select company(s)"
                                />
                              </div>
                              <div>
                                <div className="block text-sm font-medium text-gray-700 mb-2">Location of Company</div>
                                <Selection
                                  multiple
                                  value={companyGovernorates}
                                  onChange={ids => setCompanyGovernorates(ids || [])}
                                  className="w-full"
                                  list={governorateOptions}
                                  title="Select governorate(s)"
                                />
                              </div>
                            </>
                          )}
                          {showCompanyBookingFilters && (
                            <>
                              {showMinMaxAgeFilter && (
                                <div className="grid grid-cols-2 gap-3">
                                  <div>
                                    <label htmlFor="booking-filter-company-min-age-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                      Min Age
                                    </label>
                                    <input
                                      id="booking-filter-company-min-age-desktop"
                                      type="number"
                                      min="0"
                                      value={companyMinAge}
                                      onChange={e => setCompanyMinAge(e.target.value)}
                                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                      placeholder="Min"
                                    />
                                  </div>
                                  <div>
                                    <label htmlFor="booking-filter-company-max-age-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                      Max Age
                                    </label>
                                    <input
                                      id="booking-filter-company-max-age-desktop"
                                      type="number"
                                      min="0"
                                      value={companyMaxAge}
                                      onChange={e => setCompanyMaxAge(e.target.value)}
                                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                      placeholder="Max"
                                    />
                                  </div>
                                </div>
                              )}
                              <div>
                                <div className="block text-sm font-medium text-gray-700 mb-2">Blocked Countries</div>
                                <Selection
                                  multiple
                                  showSearch
                                  value={blockedCountries}
                                  onChange={ids => setBlockedCountries(ids || [])}
                                  className="w-full"
                                  list={blockedCountriesOptions}
                                  title="Select blocked countries"
                                />
                              </div>
                              <div>
                                <div className="block text-sm font-medium text-gray-700 mb-2">Instant Booking</div>
                                <Selection
                                  value={instantBooking}
                                  onChange={value => setInstantBooking(value?.id || null)}
                                  className="w-full"
                                  list={booleanFilterOptions}
                                  title="Instant Booking"
                                />
                              </div>
                            </>
                          )}
                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <label htmlFor="booking-filter-ajarlee-min-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                Ajarlee % (From)
                              </label>
                              <input
                                id="booking-filter-ajarlee-min-desktop"
                                type="number"
                                min="0"
                                value={ajarleePercentageMin}
                                onChange={e => setAjarleePercentageMin(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                placeholder="From"
                              />
                            </div>
                            <div>
                              <label htmlFor="booking-filter-ajarlee-max-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                Ajarlee % (To)
                              </label>
                              <input
                                id="booking-filter-ajarlee-max-desktop"
                                type="number"
                                min="0"
                                value={ajarleePercentageMax}
                                onChange={e => setAjarleePercentageMax(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                placeholder="To"
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <label htmlFor="booking-filter-deposit-min-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                Deposit Amount (From)
                              </label>
                              <input
                                id="booking-filter-deposit-min-desktop"
                                type="number"
                                min="0"
                                value={companyDepositMin}
                                onChange={e => setCompanyDepositMin(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                placeholder="From"
                              />
                            </div>
                            <div>
                              <label htmlFor="booking-filter-deposit-max-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                Deposit Amount (To)
                              </label>
                              <input
                                id="booking-filter-deposit-max-desktop"
                                type="number"
                                min="0"
                                value={companyDepositMax}
                                onChange={e => setCompanyDepositMax(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                placeholder="To"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="block text-sm font-medium text-gray-700 mb-2">VAT Tax</div>
                            <Selection value={vatTax} onChange={value => setVatTax(value?.id || null)} className="w-full" list={booleanFilterOptions} title="VAT Tax" />
                          </div>
                          <div>
                            <div className="block text-sm font-medium text-gray-700 mb-2">Delivery</div>
                            <Selection value={delivery} onChange={value => setDelivery(value?.id || null)} className="w-full" list={booleanFilterOptions} title="Delivery" />
                          </div>
                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <label htmlFor="booking-filter-delivery-fee-min-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                Delivery Fees (From)
                              </label>
                              <input
                                id="booking-filter-delivery-fee-min-desktop"
                                type="number"
                                min="0"
                                value={deliveryFeeMin}
                                onChange={e => setDeliveryFeeMin(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                placeholder="From"
                              />
                            </div>
                            <div>
                              <label htmlFor="booking-filter-delivery-fee-max-desktop" className="block text-sm font-medium text-gray-700 mb-2">
                                Delivery Fees (To)
                              </label>
                              <input
                                id="booking-filter-delivery-fee-max-desktop"
                                type="number"
                                min="0"
                                value={deliveryFeeMax}
                                onChange={e => setDeliveryFeeMax(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                                placeholder="To"
                              />
                            </div>
                          </div>
                          {showCreatedByFilter && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.createdBy')}</label>
                              <Selection
                                value={bookingCreatedBy}
                                onChange={handleCreatedByChange}
                                className="w-full"
                                list={CreatedBy.map(option => ({
                                  ...option,
                                  name: t(`bookings.createdBy.${option.id}`, { defaultValue: option.name }),
                                }))}
                                title={t('reports.filters.createdBy')}
                              />
                            </div>
                          )}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.bookingStatus')}</label>
                            <Selection
                              value={bookingStatus}
                              onChange={handleBookingStatusChange}
                              className="w-full"
                              list={bookingStatusOptions.map(option => ({
                                ...option,
                                name: t(`bookings.status.${option.id}`, { defaultValue: option.name }),
                              }))}
                              title={t('reports.filters.bookingStatus')}
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.paymentStatus')}</label>
                            <Selection
                              value={paymentStatus}
                              onChange={handlePaymentStatusChange}
                              className="w-full"
                              list={PaymentStatus.map(option => ({
                                ...option,
                                name: t(`bookings.paymzentStatus.${option.id}`, { defaultValue: option.name }),
                              }))}
                              title={t('reports.filters.paymentStatus')}
                            />
                          </div>
                          {!usesTenantUi && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">{t('reports.filters.partner')}</label>
                              <Selection
                                value={partner}
                                onChange={handlePartnerChange}
                                className="w-full"
                                list={partners.map(p => ({ id: p._id, name: p.name }))}
                                title={t('reports.filters.partner')}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <div className="">
        <Switch>
          <Route
            path="/transactions"
            render={() => (
              <Transactions
                isTransaction
                ref={downloadCSV}
                search={search}
                dateRange={dateRange}
                setSearchKey={setSearchKey}
                setDateRange={setDateRange}
                setScanStatus={setScanStatus}
                paymentMethod={paymentMethod}
                status={status}
              />
            )}
          />
          <Route
            path="/bookings"
            render={() => (
              <Bookings
                isTransaction
                ref={downloadCSV}
                search={search}
                dateRange={dateRange}
                setSearchKey={setSearchKey}
                setDateRange={setDateRange}
                setScanStatus={setScanStatus}
                bookingCreatedBy={bookingCreatedBy}
                bookingStatus={bookingStatus}
                paymentStatus={paymentStatus}
                partner={partner}
                bookDateTime={bookDateTime}
                bookStartDateTime={bookStartDateTime}
                bookEndDateTime={bookEndDateTime}
                companyIds={companyIds}
                companyGovernorates={companyGovernorates}
                companyMinAge={companyMinAge}
                companyMaxAge={companyMaxAge}
                blockedCountries={blockedCountries}
                instantBooking={instantBooking}
                ajarleePercentageMin={ajarleePercentageMin}
                ajarleePercentageMax={ajarleePercentageMax}
                companyDepositMin={companyDepositMin}
                companyDepositMax={companyDepositMax}
                vatTax={vatTax}
                delivery={delivery}
                deliveryFeeMin={deliveryFeeMin}
                deliveryFeeMax={deliveryFeeMax}
              />
            )}
          />
          <Route
            path="/audits"
            render={() => (
              <ActivityLogs
                isTransaction
                ref={downloadCSV}
                dateRange={dateRange}
                setSearchKey={setSearchKey}
                setDateRange={setDateRange}
                setScanStatus={setScanStatus}
                showSearch={false}
              />
            )}
          />
        </Switch>
      </div>

      <Modal></Modal>

      <Transition.Root show={showJourneyReportModal} as={Fragment}>
        <Dialog as="div" className="relative z-[11000]" onClose={setShowJourneyReportModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-[11000] overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div className="absolute top-0 right-0 pt-4 pr-4">
                    <button type="button" className="rounded-md bg-white text-gray-400 hover:text-gray-500" onClick={() => setShowJourneyReportModal(false)}>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>

                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900 mb-1">
                    User Journey Report
                  </Dialog.Title>
                  <p className="text-sm text-gray-500 mb-4">Select a booking date range. The report will be generated and downloaded. Optionally send it by email.</p>

                  <div className="mb-4">
                    <label htmlFor="journey-date-range" className="block text-sm font-medium text-gray-700 mb-2">
                      Booking Date Range
                    </label>
                    <Popover
                      custom
                      placement="bottom-start"
                      ref={journeyDatePopover}
                      content={close => (
                        <DateRangePicker
                          weekStartsOn={0}
                          locale={datePickerLocale}
                          staticRanges={localizedStaticRanges}
                          inputRanges={localizedInputRanges}
                          startDatePlaceholder={t('reports.datePicker.early')}
                          endDatePlaceholder={t('reports.datePicker.continuous')}
                          footerContent={
                            <>
                              <button
                                onClick={close}
                                className="w-[100px] mt-4 py-2 mr-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 outline-none"
                              >
                                {t('reports.datePicker.close')}
                              </button>
                              <button
                                onClick={() => {
                                  setJourneyDateRange({
                                    startDate: moment().startOf('day').toDate(),
                                    endDate: moment().endOf('day').toDate(),
                                    key: 'selection',
                                  })
                                }}
                                className="w-[100px] mt-4 py-2 mr-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 outline-none"
                              >
                                {t('reports.datePicker.clear')}
                              </button>
                            </>
                          }
                          ranges={[{ ...journeyDateRange }]}
                          onChange={item => {
                            const selection = item?.range1 || item?.selection
                            if (!selection) return
                            const startDate = new Date(selection.startDate)
                            startDate.setHours(0, 0, 0, 0)
                            const endDate = new Date(selection.endDate)
                            endDate.setHours(23, 59, 59, 999)
                            setJourneyDateRange({
                              startDate,
                              endDate,
                              key: 'selection',
                            })
                          }}
                        />
                      )}
                    >
                      <button
                        id="journey-date-range"
                        type="button"
                        className="inline-flex w-full h-[36px] justify-center items-center border border-gray-300 shadow-sm text-sm leading-4 font-regular rounded-md text-gray-700 bg-white hover:bg-gray-50 outline-none px-3"
                      >
                        <CalendarIcon className={`h-4 w-4 text-gray-500 ${isRTL ? 'ml-4' : 'mr-4'}`} />
                        <span className="truncate">
                          {journeyDateRange.startDate && journeyDateRange.endDate
                            ? `${moment(journeyDateRange.startDate).format('MMM Do, YYYY')}  -  ${moment(journeyDateRange.endDate).format('MMM Do, YYYY')}`
                            : t('reports.filters.selectDateRange')}
                        </span>
                      </button>
                    </Popover>
                  </div>

                  <div className="mb-4">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={journeySendEmail}
                        onChange={e => setJourneySendEmail(e.target.checked)}
                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                      />
                      <span className="text-sm font-medium text-gray-700">Send report via email</span>
                    </label>
                  </div>

                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                    <Button onClick={handleGenerateJourneyReport} disabled={generatingJourneyReport} className="w-full sm:w-auto flex items-center justify-center gap-2">
                      {generatingJourneyReport ? (
                        <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                      ) : null}
                      Generate
                    </Button>
                    <Button variant="outline" onClick={() => setShowJourneyReportModal(false)} disabled={generatingJourneyReport} className="w-full sm:w-auto mt-2 sm:mt-0">
                      Cancel
                    </Button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </Layout>
  )
}

export default Reports
